import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsTextWithImageBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsTextWithImageBlockEntity
